import { RentTermsContainer } from '../../containers/advancedFilters/RentTermsContainer';
import { IFilter } from '../../types/advancedFilters';

export const rentTerms: IFilter = {
  component: RentTermsContainer,
};
